import { StateMachine } from "@/core/arch/state_machine";
import type { StaffRepository } from "./staff_repository";
import type { StaffRow } from "./types";

export interface StaffListState {
  items: StaffRow[];
  status: "idle" | "loading" | "loaded" | "error";
  error?: string;
}

export class StaffListBloc extends StateMachine<StaffListState> {
  constructor(
    private repo: StaffRepository,
    private businessId: string,
  ) {
    super({ items: [], status: "idle" });
  }

  async load(): Promise<void> {
    this.setState({ ...this.state, status: "loading", error: undefined });
    try {
      const items = await this.repo.listByBusiness(this.businessId);
      this.setState({ items, status: "loaded" });
    } catch (e) {
      this.setState({
        ...this.state,
        status: "error",
        error: e instanceof Error ? e.message : "Failed to load staff",
      });
    }
  }
}
